export default [
    {
        id: 1,
        description: `"A testimonial describing what the person thinks about this service, product or startup in general."`,
        img: "1.png",
        name: "Name Surname",
        title: "Description",
        socialIcons: {
            twitterIcon: "TwitterIcon.svg",
            facebookIcon: "FacebookIcon.svg"
        },
    },
    {
        id: 2,
        description: `"A testimonial describing what the person thinks about this service, product or startup in general."`,
        img: "2.png",
        name: "Name Surname",
        title: "Description",
        socialIcons: {
            twitterIcon: "TwitterIcon.svg",
            facebookIcon: "FacebookIcon.svg"
        },
    },
    {
        id: 3,
        description: `"A testimonial describing what the person thinks about this service, product or startup in general."`,
        img: "3.png",
        name: "Name Surname",
        title: "Description",
        socialIcons: {
            twitterIcon: "TwitterIcon.svg",
            facebookIcon: "FacebookIcon.svg"
        },
    }
]